var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuardCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 66,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.571411,
    width: 64,
    height: 64.5714,
    rx: 32,
    fill: "#D9F4E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3908_101874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 28.0298C47.9948 25.1894 47.9911 22.4193 47.9911 20.0982C42.0186 18.8341 36.6357 16.9823 32.0049 14.7009V14.6964C32.0049 14.6964 32.0015 14.6979 32 14.6986C31.9986 14.6979 31.9967 14.6972 31.9952 14.6964V14.7009C27.3647 16.9823 21.9815 18.8341 16.009 20.0982C16.009 22.4193 16.0053 25.1894 16 28.0298C15.981 38.1765 22.2364 47.3479 31.9952 52.0223V52.0271C31.9952 52.0271 31.9971 52.0264 31.9986 52.0253C31.9989 52.0253 31.9997 52.0249 32 52.0245C32.0004 52.0245 32.0012 52.0249 32.0015 52.0253C32.003 52.026 32.0038 52.0264 32.0049 52.0271V52.0223C41.7637 47.3479 48.0191 38.1765 48 28.0298Z",
    fill: "#3DC289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1466 40.5951L22.3818 33.8657L24.9432 31.3178L29.1466 35.4992L39.0575 25.6401L41.6189 28.1881L29.1466 40.5951Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3908_101874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 37.3304,
    fill: "white",
    transform: "translate(16 14.6964)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardCheck);
export default __webpack_public_path__ + "static/media/guard_check.2623dd9aa0047b2cb2ed447127b985a4.svg";
export { ForwardRef as ReactComponent };